<template>
    <div height="medium" width="large">
        <div class="container">
            <h2 class="heading">{{ $t('modals.patient.tab.label_two') }}</h2>
            <document-tab :activeTab="activeTab" @toggle="toggleTab"></document-tab>

            <document-tab-content
                :physician="{
                    ViewTab: isViewTabActive,
                    UploadTabs: isUploadTabActive,
                    SummaryTab: isSummaryTabActive,
                }"
                @toggle="toggleTab"
            ></document-tab-content>
        </div>
    </div>
</template>

<script>
    import PageWithDataMixin from 'mixins/PageWithDataMixin'
    import FormMixin from 'mixins/FormMixin'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'
    import DocumentTab from 'components/forms/patient/DocumentTabs'
    import DocumentTabContent from 'components/forms/patient/DocumentTabContent'

    const TabEnum = Object.freeze({
        VIEW: 'view',
        UPLOAD: 'upload',
        SUMMARY: 'summary',
    })

    export default {
        mixins: [PageWithDataMixin, FormMixin, HandleRequestMixin],
        components: {
            DocumentTab,
            DocumentTabContent,
        },
        props: {
            initialTab: {
                type: String,
                default: TabEnum.VIEW,
            },
        },
        data() {
            return {
                TabEnum,
                activeTab: this.initialTab || TabEnum.VIEW,
                isViewTabActive: this.initialTab === TabEnum.VIEW,
                isUploadTabActive: this.initialTab === TabEnum.UPLOAD,
                isSummaryTabActive: this.initialTab === TabEnum.SUMMARY,
            }
        },

        methods: {
            toggleTab(name) {
                this.activeTab = name
                this.isViewTabActive = false
                this.isUploadTabActive = false
                this.isSummaryTabActive = false
                switch (name) {
                    case TabEnum.VIEW:
                        this.isViewTabActive = true
                        break
                    case TabEnum.UPLOAD:
                        this.isUploadTabActive = true
                        break
                    case TabEnum.SUMMARY:
                        this.isSummaryTabActive = true
                        break
                }
            },
        },

        watch: {
            initialTab(newTab) {
                if (newTab) {
                    this.toggleTab(newTab)
                }
            },
        },
    }
</script>
<style lang="css" scoped>
    .heading {
        font-size: 16px;
        color: oklch(0.21 0.034 264.665);
        font-weight: 500;
        margin-bottom: 14px;
    }
</style>
